import React, { ReactNode } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Translate } from 'react-redux-i18n';
import rightChevron from '../../img/icones/chevron_droite.svg';

type Props = RouteComponentProps & {
  i18nKey: string,
  image: string,
  url?: string,
};

type State = {
};

class NavigationBackButton extends React.Component<Props, State> {
  state: State = {
  };

  static defaultProps = {
    url: null,
  };

  render(): ReactNode {
    return (
      <button type="button" className="navigation-back-button" onClick={() => (this.props.url ? this.props.history.push(this.props.url) : this.props.history.goBack())}>
        <img className="left-chevron" src={rightChevron} alt="" />
        <img className="logo" src={this.props.image} alt="" />
        <h3><Translate value={this.props.i18nKey} /></h3>
      </button>
    );
  }
}

export default withRouter(NavigationBackButton);
